type SortingMethod<T> = (
  a: T | undefined | null,
  b: T | undefined | null,
) => number;

interface SortingMethods {
  string: SortingMethod<string>;
  number: SortingMethod<number>;
  date: SortingMethod<string>;
  boolean: SortingMethod<boolean>;
}

const tableSortingMethods: SortingMethods = {
  string: (a, b) => (a ?? '').localeCompare(b ?? ''),
  number: (a, b) => (a ?? 0) - (b ?? 0),
  date: (a, b) => new Date(a ?? '').getTime() - new Date(b ?? '').getTime(),
  boolean: (a, b) => (a === b ? 0 : a ? -1 : 1),
};

export { tableSortingMethods };
